module.exports = __webpack_public_path__ + "static/media/thumb.61880fe5.jpg";